module.exports = __webpack_public_path__ + "static/img/InvEduEn.f361a7a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/InvEduEn.jpg
// module id = tQtg
// module chunks = 5